import {Injectable} from '@angular/core';
import {FilterService} from '../../shared/models/filter-service.model';
import {Subject} from 'rxjs/Subject';
import {ThreadsFilter} from '../models/thread-filter.model';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ThreadFilterService implements FilterService {

	private filterSubject = new Subject<ThreadsFilter>();
	private filterObservable$ = this.filterSubject.asObservable();

	private currentFilter: ThreadsFilter;
	private lastFilter: ThreadsFilter;


	getFilterObservable(): Observable<ThreadsFilter> {
		return this.filterObservable$;
	}

	updateFilter(filter: ThreadsFilter): void {
		this.currentFilter = filter;
		this.filterSubject.next(filter);
		if (this.currentFilter !== null) {
			this.lastFilter = this.currentFilter;
		}
	}

	getCurrentFilter(): ThreadsFilter {
		return this.currentFilter;
	}

	getEmptyFilter(): ThreadsFilter {
		return this.currentFilter = new ThreadsFilter();
	}

	reloadLastFilter() {
		this.updateFilter(this.lastFilter);
	}

}
